<div class="cards-grid-box">
  <ng-container *ngFor="let column of columns">
    <app-driveb-kanban-column
      [icon]="column.icon"
      [tooltip]="column.tooltip"
      [title]="column.title"
      [cards]="column.cards"
      [key]="column.key"
      [totalElements]="column.pageManager.totalElements"
      [cardTemplate]="cardTemplate"
      (reachedEnd)="reachedEndColumn.emit($event)"
    ></app-driveb-kanban-column>
  </ng-container>
</div>
